import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { Stack, Select, FormControl, Button, Grid, TextField, MenuItem, Divider } from '@mui/material'

const RulesComponent = ({ rules, steps, currentStep, onSubmit }) => {

    const { t } = useTranslation();
    const [actionType, setActionType] = useState();

    const conditionsType = {
        Equals: {
            value: 1, label: t('Equals')
        },
        NotEquals: {
            value: 2, label: t('NotEquals')
        },
        Contains: {
            value: 3, label: t('Contains')
        },
        NotContains: {
            value: 4, label: t('NotContains')
        },
        GreaterThan: {
            value: 5, label: t('GreaterThan')
        },
        GreaterOrEquals: {
            value: 6, label: t('GreaterOrEquals')
        },
        LessThan: {
            value: 7, label: t('LessThan')
        },
        GreateLessOrEqualsrThan: {
            value: 8, label: t('LessOrEquals')
        },
        In: {
            value: 9, label: t('In')
        },
        NotIn: {
            value: 10, label: t('NotIn')
        },
    };

    const actionTypes = {
        GoTo: { value: 1, label: t('GoTo') },
        StayOk: { value: 2, label: t('StayOk') },
        StayError: { value: 3, label: t('StayError') },
        Return: { value: 4, label: t('Return') },
    }

    const saveRule = () => {

        if (onSubmit) {
            onSubmit(rules);
        }
    }

    const formItems = rules?.map((rule, index) => {

        const onChangeActionType = (event) => {
            rule.action.type = event.target.value;
            setActionType(event.target.value);
        }

        const conditionsInputs = rule.conditions?.map((condition, conditionIndex) => {
            return (
                <Grid key={conditionIndex} sx={{ width: '100%' }} alignItems="start" display="flex" >
                    <Grid item key={"baseValue"}>
                        <FormControl key={"baseValue"}>
                            <Select
                                id={'baseValue'}
                                name={'baseValue'}
                                value={condition.baseValue}
                                onChange={(event) => condition.baseValue = event.target.value}
                                renderValue={(selected) => steps.find(s => `{{${s.code}}}` === condition.baseValue)?.code}
                                required={true}
                            >
                                {steps.map(s => <MenuItem key={s.code} value={`{{${s.code}}}`}>{s.code}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item key={"type"}>
                        <FormControl key={"type"}>
                            <Select
                                id={'type'}
                                name={'type'}
                                value={condition.type}
                                onChange={(event) => condition.type = event.target.value}
                                renderValue={(selected) => conditionsType[condition.type].label}
                                required={true}
                            >
                                {Object.keys(conditionsType).map(s => <MenuItem key={s} value={s}>{conditionsType[s].label}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid >

                    <Grid item key={"checkValue"}>
                        <TextField
                            key={"checkValue"}
                            variant="outlined"
                            type={'text'}
                            id={"checkValue"}
                            name={"checkValue"}
                            defaultValue={condition.checkValue}
                            onChange={(event) => condition.checkValue = event.target.value}
                            required={true}
                        />
                    </Grid>
                </Grid>
            );
        });

        const validTargets = steps.filter(s => s.code !== currentStep.code);
        const actionInputs = (
            <Grid key={"action"} sx={{ width: '100%' }} alignItems="start" display="flex" >
                <Grid item key={"type"}>
                    <FormControl>
                        <Select
                            id={'type'}
                            name={'type'}
                            value={rule.action.type}
                            onChange={(event) => onChangeActionType(event)}
                            renderValue={(selected) => actionTypes[rule.action.type].label}
                            required={true}
                        >
                            {Object.keys(actionTypes).map(s => <MenuItem key={s} value={s}>{actionTypes[s].label}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Grid>

                {rule.action.type === 'GoTo' &&

                    <Grid item key={"value"}>
                        <FormControl>
                            <Select
                                id={'value'}
                                name={'value'}
                                value={rule.action.value || validTargets.length > 0 ? validTargets[0].code : ''}
                                onChange={(event) => rule.action.value = event.target.value}
                                renderValue={(selected) => {
                                    return steps.find(s => s.code === rule.action.value)?.code
                                }}
                            >
                                {validTargets.map(s => <MenuItem key={s.code} value={s.code}>{s.code}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                }
            </Grid>
        );

        return <div key={index}>
            {conditionsInputs}
            {actionInputs}
            <Divider
                sx={{ ...{ my: 3, width: '100%' } }}
                key={index}
                style={{ fontSize: '1.5rem', fontWeight: 'bold' }}
            >
            </Divider>
        </div>
    });

    return (
        <form onSubmit={(event) => { event.preventDefault(); saveRule() }} autoComplete="off" className="form-flex" style={{ m: 1, minWidth: 240, minHeight: 240, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', }}>
            <Stack direction="column" alignItems="start" justifyContent="space-between">
                {formItems}
            </Stack>
            {currentStep.rules && <Button type="submit" >Salvar</Button>}
        </form>
    );
};

export default RulesComponent;